import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/improve-info.css"

import { HandleImages } from "../components/functions"
import Img from "gatsby-image"
import hacker from "../images/hacker.webm"
import shield from "../images/shield.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"

import web from "../images/spider-web.svg"


const style = {}
var height
var position

class LearnInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active:true
    }
  
  }

  
  componentDidMount() {
      var current=this;
    console.log('mount',this.state.active);
    this.setState({
      safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
  })
   
   /* setInterval(function() {
        current.setState({
          active: !current.state.active
        });
      }, 5000)*/
  }


 
  render() {
     
    return (
      <div className="improve-info-wrapper">
        <div className="top">
          <img className='bg' src={web}/>
          <div className="left">
            {" "}
            <div>

                 
            <OnVisible className="video-wrapper">
           


                {this.state.safari?<HandleImages name="hacker"/>:        <video autoplay="true" loop="true" muted="true">
                  <source src={hacker} type="video/webm" />
                </video>}
              </OnVisible>
              <div>
              
                <p>Keeping pace with threats and hacker sophistication is hard work. </p>
                
              </div>
           
              <div>
              
                <h3>Cyber certs and accreditations can get stale and out of date.</h3>
                <p>But keeping up through classroom lectures or videos is less than exciting. The  information is hard to hang on to and really use.  And it feels disconnected from what you have to do on the job everyday. </p>
                
              </div>
              
            </div>
    
          </div>

 
        </div>
        <div className="blue">
          <ul>
            <li>Build cyber skills</li>
            <li>Stop imminent threats</li>
            <li>Repeat</li></ul>
        </div>

        <div className="bottom">
            
          <div className="left">

          <HandleImages name="aresSplash"/>
          <div>              <h3>Welcome to a whole new way to make training and<br/> cyber skill building easy... with a bit of fun thrown in.</h3>
              <p>Introducing Project Ares: an award-winning online cyber security training platform that helps professionals advance their career, grow in abilities, and align to specialized workroles.</p></div>

           
          </div>

                   
          <OnVisible className="video-wrapper">
          {this.state.safari?<HandleImages name="shield"/>:        <video autoplay="true" loop="true" muted="true">
                  <source src={shield} type="video/webm" />
                </video>}
              </OnVisible>
          <div className="right">
      <div>
           <h3>We think it's time to change how<br/> cyber professionals learn cyber security.</h3>

           <div>
               <div className="icon">
                 
               <svg   viewBox="0 0 73.6 73.6"  >
 
<g>
    <g>
        <g>
            <path class="st0" d="M24.8,63.6L10,48.7l4.1-4.1l14.9,14.9L24.8,63.6z M11.4,48.7l13.5,13.5l2.7-2.7L14.1,46L11.4,48.7z"/>
        </g>
        <g>
            <path class="st0" d="M11,69.8l-7.3-7.3l10.7-10.7l7.3,7.3L11,69.8z M5.2,62.5l5.9,5.9l9.3-9.3l-5.9-5.9L5.2,62.5z"/>
        </g>
        <g>
            <path class="st0" d="M9.6,73.6c-0.7,0-1.4-0.3-1.9-0.8l-6.8-6.8c-1.1-1.1-1.1-2.8,0-3.9c1-1,2.8-1,3.9,0l6.8,6.8
                c1.1,1.1,1.1,2.8,0,3.9C11,73.3,10.3,73.6,9.6,73.6z M2.7,62.2c-0.5,0-0.9,0.2-1.2,0.5c-0.7,0.7-0.7,1.8,0,2.5l6.8,6.8
                c0.7,0.7,1.8,0.7,2.5,0c0.7-0.7,0.7-1.8,0-2.5L4,62.8C3.6,62.4,3.2,62.2,2.7,62.2z"/>
        </g>
        <g>
            <path class="st0" d="M17.7,62.9c-0.1,0-0.3,0-0.4-0.1l-6.5-6.5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l6.5,6.5
                c0.2,0.2,0.2,0.5,0,0.7C18,62.8,17.9,62.9,17.7,62.9z"/>
        </g>
        <g>
            <path class="st0" d="M14.4,66.4c-0.1,0-0.3,0-0.4-0.1l-6.7-6.7c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l6.7,6.7
                c0.2,0.2,0.2,0.5,0,0.7C14.6,66.3,14.5,66.4,14.4,66.4z"/>
        </g>
        <g>
            <g>
                <path class="st0" d="M25.4,57c-0.3,0-0.6-0.1-0.8-0.3L16.9,49c-0.4-0.4-0.4-1.2,0-1.6L62.3,2c0.2-0.2,0.4-0.3,0.6-0.3L72.2,0
                    c0.4-0.1,0.7,0.1,1,0.3c0.3,0.3,0.4,0.6,0.3,1l-1.7,9.3c0,0.2-0.2,0.4-0.3,0.6L26.2,56.7C26,56.9,25.7,57,25.4,57z M72.4,1
                    C72.4,1,72.4,1,72.4,1l-9.3,1.7L17.6,48.1c-0.1,0.1-0.1,0.2,0,0.2l7.6,7.6c0,0,0.2,0.1,0.2,0l45.4-45.4l1.7-9.4
                    c0,0,0-0.1-0.1-0.1C72.5,1,72.4,1,72.4,1z"/>
            </g>
        </g>
        <g>
            <path class="st0" d="M21.1,52.9c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7L66.6,6.2c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7
                L21.5,52.8C21.4,52.9,21.2,52.9,21.1,52.9z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M41.4,70.6c-0.2,0-0.4,0-0.5-0.1c-4.4-2.3-8.4-5.3-11.9-8.8c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0
                c3.4,3.4,7.4,6.3,11.7,8.6l0.4,0.4l-0.2-0.4C57.2,61.3,67,45.1,67,27.3c0-3.1-0.3-6.2-0.9-9.3c-0.1-0.3,0.1-0.5,0.4-0.6
                c0.3-0.1,0.5,0.1,0.6,0.4c0.6,3.1,0.9,6.3,0.9,9.5C68,45.5,58,62,41.9,70.4C41.7,70.5,41.5,70.6,41.4,70.6z"/>
        </g>
        <g>
            <path class="st0" d="M18.4,45c-0.2,0-0.4-0.1-0.5-0.3c-2.1-5.6-3.2-11.4-3.2-17.4c0-4.7,0.7-9.4,2-13.9c0.1-0.5,0.6-0.8,1.1-0.8
                c4.5,0,8.1-3.6,8.1-8.1c0-0.3,0.1-0.7,0.4-0.9c0.2-0.2,0.6-0.3,0.9-0.3c9.4,0.9,18.8,0.9,28.2,0c0.3,0,0.7,0.1,0.9,0.3
                c0.2,0.2,0.4,0.5,0.4,0.9c0,0.6,0.1,1.3,0.2,1.9c0.1,0.3-0.1,0.5-0.4,0.6C56.3,6.9,56,6.8,56,6.5c-0.2-0.7-0.2-1.4-0.2-2.1
                c0-0.1,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1,0c-9.4,0.9-18.9,0.9-28.4,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,5-4.1,9.1-9.1,9.1
                c-0.1,0-0.2,0.1-0.2,0.1c-1.3,4.4-2,9-2,13.6c0,5.9,1.1,11.6,3.1,17.1c0.1,0.3,0,0.5-0.3,0.6C18.5,45,18.4,45,18.4,45z"/>
        </g>
        <g>
            <path class="st0" d="M22.4,41c-0.2,0-0.4-0.1-0.5-0.3c-1.4-4.3-2.1-8.8-2.1-13.3c0-3.1,0.3-6.2,1-9.2c0.1-0.3,0.3-0.4,0.6-0.4
                c0.3,0.1,0.4,0.3,0.4,0.6c-0.6,2.9-1,6-1,9c0,4.5,0.7,8.8,2,13c0.1,0.3-0.1,0.5-0.3,0.6C22.5,40.9,22.5,41,22.4,41z"/>
        </g>
        <g>
            <path class="st0" d="M41.4,64.6c-0.2,0-0.4-0.1-0.6-0.2c-4.3-2.6-8-5.8-11.1-9.7c-0.2-0.2-0.1-0.5,0.1-0.7
                c0.2-0.2,0.5-0.1,0.7,0.1c3,3.7,6.7,6.9,10.9,9.4c0.3,0,0.5,0.2,0.5,0.5C41.8,64.4,41.6,64.6,41.4,64.6z"/>
        </g>
    </g>
</g>
</svg>

               </div>
           <p>Project Ares is a new level of experience-based learning for cyber professionals.</p>
           </div>
           
           <div>
               <div className="icon">
                 

               <svg   viewBox="0 0 73.3 45.8" >
 
<g>
    <g>
        <path class="st0" d="M8.2,45.8c-1.5,0-3-0.4-4.3-1.3c-1.8-1.2-5.6-4.9-3-14.3C1.5,28,2,25.8,2.6,23.8C6,10.5,8.7,0,19,0h35.2
            c10.3,0,13,10.5,16.5,23.7c0.5,2.1,1.1,4.3,1.7,6.5c2.6,9.3-1.2,13.1-3,14.3c-2.8,1.9-6.6,1.7-9.5-0.5c-3.6-2.8-8.4-12.3-9.2-14.1
            H22.6C21.7,31.7,17,41.2,13.3,44C11.8,45.2,10,45.8,8.2,45.8z M19,1C9.5,1,6.9,11.2,3.5,24c-0.5,2.1-1.1,4.3-1.7,6.5
            c-1.7,6.1-0.8,10.9,2.6,13.2c2.5,1.7,5.8,1.5,8.3-0.4c3.7-2.9,9-13.9,9.1-14c0.1-0.2,0.3-0.3,0.5-0.3H51c0.2,0,0.4,0.1,0.5,0.3
            c0.1,0.1,5.4,11.1,9.1,14c2.5,1.9,5.8,2.1,8.3,0.4c3.3-2.2,4.3-7,2.6-13.2l0,0c-0.6-2.2-1.2-4.4-1.7-6.5C66.4,11.1,63.8,1,54.2,1
            H19z"/>
    </g>
    <g>
        <path class="st0" d="M20.4,22.1c-0.6,0-1-0.4-1-1V8.8c0-0.6,0.4-1,1-1s1,0.4,1,1v12.3C21.4,21.7,21,22.1,20.4,22.1z"/>
    </g>
    <g>
        <path class="st0" d="M26.6,16H14.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h12.3c0.6,0,1,0.4,1,1S27.1,16,26.6,16z"/>
    </g>
    <g>
        <path class="st0" d="M59.1,16.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S60,16.6,59.1,16.6z M59.1,14.6
            c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S59.3,14.6,59.1,14.6z"/>
    </g>
    <g>
        <path class="st0" d="M47,16.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S47.9,16.6,47,16.6z M47,14.6
            c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S47.2,14.6,47,14.6z"/>
    </g>
    <g>
        <path class="st0" d="M53.1,10.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S54,10.6,53.1,10.6z M53.1,8.6
            c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S53.3,8.6,53.1,8.6z"/>
    </g>
    <g>
        <path class="st0" d="M53.1,22.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S54,22.6,53.1,22.6z M53.1,20.6
            c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S53.3,20.6,53.1,20.6z"/>
    </g>
</g>
</svg>

               </div>
           <p>You get your hands on the keyboard and your head in the game.</p>
           </div>
           
           <div>
               <div className="icon">
                 

               <svg  viewBox="0 0 61 63.4" >
 
<path class="st0" d="M7.2,62.9c2.1,0,4.1-0.8,5.7-2.1l2.9-2.3c2-1.6,4.5-2.3,7-2c1.6,0.2,3.5,0.3,5.6,0.3c7.9,0,19.2-2,29.9-10.8
    c3.4-2.8,2-7.6,0.1-11.9c-2.6-6-8.2-15.2-15.7-27.1c-1-1.6-2.5-2.9-4.2-3.6C34,1.5,30.4,0.6,27,0.5c-1.7,0-3.3,0.7-4.6,2.2
    c-1.2,1.4-2.9,5.4-3.4,8.4c-0.4,2.1,0.4,3.4,1.2,4.1c2.1,1.9,6.3,1.9,13.3,0.1c2.5,3.4,2.8,6.7,3.2,10.2c0.2,1.6,0.3,3.2,0.7,4.8
    c-4.1-1.8-7.8-1.4-10.3-0.6c-1.8,0.6-3.3,1.4-4.3,2.1c-1.7-2.3-3.9-4-6.7-4.8c-2.9-0.9-6-0.9-8.9,0.1c-1.4,0.5-2.6,0.4-3.5-0.2
    c-1-0.7-2.3-0.7-3.4-0.1"/>
<path class="st0" d="M43,44.4c-3.5,2.7-7.9,4.2-12.6,4.2c-3.9,0-7.6-1.1-10.7-3"/>
</svg>
               </div>
           <p>When you take action, you get to demonstrate your cyber “fitness”.</p>
           </div>
           
           
           </div>
          </div>
        </div>




   
         
        <div className="last">
      <div className="logo-wrapper"><img alt="Project Ares Logo" src={pAIcon} /> </div>  <p>
      Try it out to keep skills sharp and then all your hard-earned credentials, certifications, and accreditations will truly reflect your ability to protect organizational networks.
      </p>
         
          </div>
      </div>
    )
  }
}

export default LearnInfo
